import { createFileRoute } from "@tanstack/react-router";
import HowSoonCanIBeSeen from "@/pages/HowSoonCanIBeSeen";
export const Route = createFileRoute("/how-soon-can-i-be-seen")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "How Soon Can I Be Seen | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "How quickly can you start depression treatment? Learn about appointment availability for TMS, SAINT TMS, and SPRAVATO in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "How Soon Can I Be Seen | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "How quickly can you start depression treatment? Learn about appointment availability for TMS, SAINT TMS, and SPRAVATO in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/how-soon-can-i-be-seen",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/how-soon-can-i-be-seen",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <HowSoonCanIBeSeen />;
}
